import React, { useEffect, useRef, useState } from 'react';
import "../assets/css/custom.css";
import "../assets/css/client.css";
import "../assets/css/management.css";
import "../assets/css/font-awesome.css";
import "../assets/css/sweetalert.css";
import "../assets/css/bootstrap.min.css";
import moment from 'moment';
import "../assets/css/steps.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faBuildingUser,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Link, useLocation } from "react-router-dom";
import { commonAPI } from "../services/CommonAPIService";
import { Stepper, Step, StepLabel } from "@mui/material";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import INDFlag from "../assets/img/INDFlag.jpg";
import filepreview from '../assets/img/filepreview.png';
import { ErrorSource } from "../common/constants";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import switchBaseClasses from "@mui/material/internal/switchBaseClasses";
import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import noticeuserupload from '../assets/img/noticeuserupload.png';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import JoditEditor from 'jodit-react';
import Form from 'react-bootstrap/Form';
import Box from '@mui/material/Box';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Table from 'react-bootstrap/Table';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import ratingstar from '../assets/img/ratingstar.png';
import ReactStars from "react-rating-stars-component";
import DownImage from '../assets/img/cd.png'
import UpImage from '../assets/img/cu.png'
import assignedimg from '../assets/img/assignedimg.png'
import noimg from '../assets/img/noimg.png';
import { set } from 'date-fns';
import { ErrorLog } from '../common/utility';
import { stringify } from 'ajv';
import Select from 'react-select';
import SelectSearch from "react-dropdown-select";
import { Chart } from "react-google-charts";
import Escalation from './Escalation';

function Helpdesk() {
  const Status = localStorage.getItem("StatusHelp");
  const UrgentStatsStatus = localStorage.getItem("UrgentStats");
  const isUrgentStats = UrgentStatsStatus === "true";
  const StatsTodayStart = localStorage.getItem("TodayStartDate");
  const StatsEndStart = localStorage.getItem("TodayEndDate");
  const StatsLevel = localStorage.getItem("SocietyLevel");
  const [reopenBtn, setShowReopenBtn] = useState(false);
  const [compRating, setCompRating] = useState(null);

  const [show, setShow] = useState(0)
  const [show1, setShow1] = useState(0)
  const [show2, setShow2] = useState(0)
  const [show9, setShow9] = useState(0)
  const [show8, setShow8] = useState(false)
  const [AdvanceShow, setAdvanceShow] = useState(false)
  const [fullscreen, setFullscreen] = useState(true);
  const [loading, setLoading] = useState(false);

  // states for tower
  const [towerId, setTowerId] = useState("");
  const [towerList, setTowerList] = useState([])
  const [towerIdComplainee, setTowerIdComplainee] = useState("");

  // state for flat
  const [flatList, setFlatList] = useState([]);
  const [flatListComplainee, setFlatListComplainee] = useState([]);
  const [flatListId, setFlatListId] = useState("");
  const [flatComplaineeId, setFlatComplaineeId] = useState("");

  // state for complaint status
  const [complaintStatusId, setComplaintStatusId] = useState("");
  const [statusId, setStatusId] = useState(Status ? Status : "");
  const [statusName, setStatusName] = useState("");
  const [complaintStatusList, setComplaintStatusList] = useState([]);

  // state for Service staff
  const [serviceStaffList, setServiceStaffList] = useState([]);
  const [serviceStaffId, setServiceStaffId] = useState("");
  const [serviceStaffIdComplainee, setServiceStaffIdComplainee] = useState("");

  // state for complaint 
  const [compaintList, setComplaintList] = useState([]);
  const [complaintDesc, setComplaintDesc] = useState("");
  const [complaintDetails, setComplaintDetails] = useState(null);
  const [complaintImageList, setComplaintImageList] = useState([]);

  // state for category
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [categoryIdComplainee, setCategoryIdComplainee] = useState("");
  const [categoryNameComplainee, setCategoryNameComplainee] = useState("");

  const [subcategoryList, setSubCategoryList] = useState([])
  const [subCategoryId, setSubCategoryId] = useState("")
  const [subCategoryNameComplainee, setSubCategoryNameComplainee] = useState(null)

  // state for resident
  const [residentList, setResidentList] = useState([])
  const [residentId, setResidentId] = useState("");

  // state for urgency
  const [isUrgent, setIsUrgent] = useState(isUrgentStats ? isUrgentStats : "null");
  const [isUrgentComplainee, setIsUrgentComplainee] = useState(false);

  // state for requestType save
  const [requestType, setRequestType] = useState("");

  const [complaintPage, setComplaintPage] = useState(0);
  const [complaintLoadingMore, setComplaintLoadingMore] = useState(false);
  const [hasMoreComplaints, setHasMoreComplaints] = useState(true);
  const complaintLoadingMoreRef = useRef(false);
  // state for image base64;
  const [base64img, setBase64img] = useState([]);

  // state for showless and show more
  const [showMore, setShowMore] = useState(false);

  // state for ETA date
  const [ETAdate, setETADate] = useState(null);

  //state for userComment
  const [userComment, setUserComment] = useState("");

  // state for reasonList
  const [reasonList, setReasonList] = useState([]);
  const [reasonId, setReasonId] = useState("")
  const [isDisabled, setIsDisabled] = useState(true);

  const [imgSrc, setImgSrc] = useState("");
  const [AppLevel, setAppLevel] = useState(StatsLevel ? StatsLevel : null);

  // state for getting ETA from complaint Details

  const [complaintETA, setComplaintETA] = useState(null);


  const [AssignedLoading, setAssignedLoading] = useState(false);
  const [AssignedCount, setAssignedCount] = useState([]);
  const [assignmentModal, setAssignmentModal] = useState(false);
  const [HoldSetting, setHoldSetting] = useState([]);
  const [ReopenHourSetting, setReopenHourSetting] = useState([]);
  const [ReopenResidentSetting, setReopenResidentSetting] = useState([]);
  const [ResolveSetting, setResolveSetting] = useState([]);


  // split comments
  const [lines, setLines] = useState([]);

  const allowChange = useRef(null);

  const convertDateSend = (date) => {
    // Check if the date is valid
    if (date && typeof date === 'string') {
      // Create a Date object from the input string
      const dateObj = new Date(date);

      // Check if the date is valid
      if (isNaN(dateObj.getTime())) {
        console.warn("Invalid date string");
        return null;
      }

      // Extract year, month, and day
      const yyyy = dateObj.getFullYear();
      const mm = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const dd = String(dateObj.getDate()).padStart(2, '0');

      // Format the date as DD-MM-YYYY
      const formattedDate = `${yyyy}-${mm}-${dd}`;
      return formattedDate;
    } else {
      console.warn("Input date string may be null, empty string, or undefined");
      return null;
    }
  };


  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [slideshowHeight, setSlideshowHeight] = useState(0);
  console.log("selectedOptions", selectedOptions);
  const [startDate, setStartDate] = useState(StatsTodayStart ? `${convertDateSend(StatsTodayStart)}T00:00:00` : null);
  const [endDate, setEndDate] = useState(StatsEndStart ? `${convertDateSend(StatsEndStart)}T23:59:00` : null);
  const [showEscalationModal, setShowEscalationModal] = useState(false);

  console.log("complaintDetails are", complaintDetails);
  console.log("ETA DATE IS", ETAdate)
  // const handleChange = (selected) => {
  //   setSelectedOptions(selected);
  // };

  const optionsCategory = categoryList.map(item => ({
    value: item.categoryId,
    label: item.categoryName,
  }));

  const optionsStaff = serviceStaffList.map(item => ({
    value: item.staffId,
    label: item.userName,
  }));

  const updateSlideshowHeight = () => {
    const winHeight = window.innerHeight; // Get the window height
    setSlideshowHeight(winHeight - 270); // Set the slideshow height
  };

  useEffect(() => {
    updateSlideshowHeight();
    GetAssigned();
    window.addEventListener('resize', updateSlideshowHeight);

    return () => {
      window.removeEventListener('resize', updateSlideshowHeight);
    };
  }, []);

  const GetAssigned = async () => {
    const auth = localStorage.getItem("userData");
    const UserData = JSON.parse(auth);
    const endPointVariableKey = {
      buildingId: UserData?.buildingId,
    };
    setAssignedLoading(true);
    try {
      let response = await commonAPI("ComplaintDashboardAssigned", undefined, endPointVariableKey);
      if (response?.success == true) {
        console.log("ComplaintDashboardAssigned", response);
        const AssignedCount = response?.data?.map(
          (item) => [formatUser(item?.userName), item?.complaintsCount, item?.complaintsCount?.toString()]
        );
        setAssignedCount(AssignedCount);
        setAssignedLoading(false);
      } else {
        toast.error("Something went wrong");
        setAssignedLoading(false);
      }
    } catch (error) {
      console.log(error);
      setAssignedLoading(false);
      ErrorLog(UserData.userId, UserData.mobileNumber, undefined, "ComplaintDashboardAssigned", "HD16", error.message, error, "HelpDesk.js", "GetAssigned");
      toast.error("Something went wrong, Please try again after some time");
    }
  };

  const data2 = [
    ["Staff Name", "Complaint Count", { role: "annotation" }],
    ...AssignedCount
  ];


  const handleCategoryChange = (selected) => {
    setSelectedCategories(selected);
    // Convert selected options to a comma-separated string
    const selectedValues = selected ? selected.map(option => option.value).join(',') : '';
    // setSelectedCategories(selectedValues)
    console.log("Selected Categories String:", selectedValues);
  };

  const handleChangeStaff = (selected) => {
    setSelectedStaff(selected);

    // Convert selected options to a comma-separated string
    const selectedValues = selected ? selected.map(option => option.value).join(',') : '';
    console.log("Selected Staff String:", selectedValues);
  };

  console.log("setSubCategoryNameComplainee", towerIdComplainee, flatComplaineeId, residentId);
  console.log("request Type", compRating);
  console.log("reasonId ", reasonId);
  // Catch Rating value


  // utility function

  const convertDate = (dateString) => {
    if (!dateString || isNaN(Date.parse(dateString))) {
      console.error("Invalid date string");
      return null;
    }
    if (dateString) {
      try {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        let month = date.toLocaleString('default', { month: 'short' }).toUpperCase();
        month = month.charAt(0).toUpperCase() + month.slice(1).toLowerCase();
        const year = date.getFullYear();

        // Get the time in 12-hour format
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? String(hours).padStart(2, '0') : '12';

        const formatted = `${day}/${month}/${year} ${hours}:${minutes}${ampm}`;
        return formatted;

      } catch (error) {

      }
    }

  };

  const convertDate_ = (dateString) => {
    // Validate the input date string
    if (!dateString || isNaN(Date.parse(dateString))) {
      console.error("Invalid date string");
      return null;
    }

    try {
      // Parse the input date string into a Date object
      const date = new Date(dateString);

      // Get day, month, year, and time
      const day = String(date.getDate()).padStart(2, '0'); // Ensure day is two digits
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Get month (0-11, so add 1)
      const year = date.getFullYear();

      // Get the time in 12-hour format
      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12; // Convert hours from 24-hour format to 12-hour format
      hours = hours ? String(hours).padStart(2, '0') : '12'; // Ensure hours are two digits

      // Format the date as DD/MM/YYYY hh:mmAM/PM
      const formatted = `${day}/${month}/${year} ${hours}:${minutes}${ampm}`;

      return formatted;

    } catch (error) {

    }

  };

  const todayDate = () => {
    try {
      // Parse the input date string into a Date object
      const date = new Date();

      // Get day, month, year, and time
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      // Format the date as DD/MM/YYYY hh:mmAM/PM
      const formatted = `${year}-${month}-${day}`;
      return formatted;
    } catch (error) {

    }

  };

  const todayDateGet = () => {
    const now = new Date();
    // Format the date to YYYY-MM-DDTHH:MM
    return now.toISOString().slice(0, 16);
  };


  const formatUser = (userName) => {
    if (!userName) {
      return;
    }
    const words = userName.split(' ');
    if (words.length > 2) {
      // Return the first two words and add ellipsis
      return `${words[0]} ${words[1]}...`;
    }
    // Return the original userName if it has 2 or fewer words
    return userName;
  };

  const GetApplicationList = async () => {
    let userData = localStorage.getItem("userData");
    userData = JSON.parse(userData);

    try {
      setLoading(true);
      const endPointVariableKey = {
        urlVariable: null,
        buildingId: userData?.buildingId
      }
      let response = await commonAPI("AppSettings", undefined, endPointVariableKey);
      console.log("AppSettings", response);
      if (response?.success === true) {
        console.log("Table AppSettings", response.data)
        const ReopenHour = response?.data.find(item => item.key === 'COMPLAINT_REOPEN_TIME_IN_HOURS')?.value;
        const ReopenResident = response?.data.find(item => item.key === 'COMPLAINT_REOPEN_FEATURE_FOR_RESIDENT')?.value;
        const HoldResident = response?.data.find(item => item.key === 'COMPLAINT_HOLD_FEATURE_FOR_RESIDENT')?.value;
        const ResolveResident = response?.data.find(item => item.key === 'COMPLAINT_RESOLVED_FEATURE_FOR_RESIDENT')?.value;
        setReopenHourSetting(parseInt(ReopenHour));
        setReopenResidentSetting(parseInt(ReopenResident));
        setHoldSetting(parseInt(HoldResident));
        setResolveSetting(parseInt(ResolveResident));
        setLoading(false);
      } else {
        toast.error("Something went wrong");
        setLoading(false);
      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      const auth = localStorage.getItem("userData");
      const myUserData = JSON.parse(auth);
      const bodyError = {
        "userId": myUserData?.userId,
        "mobileNumber": myUserData?.mobileNumber,
        "requestJSON": null,
        "uri": "/api/Master/Building",
        "errorNumber": "GB01",
        "errorSource": ErrorSource,
        "errorSummary": error.message,
        "errorDescription": error.message,
        "fileClassName": "tower.js",
        "functionName": "GetBuildingList",
      };
      let response = await commonAPI("ErrorLogMaster", bodyError);
      console.log("statusCode", response);
      setLoading(false);
      toast.error("Something went wrong");
    }

  }

  useEffect(() => {
    GetApplicationList();
  }, []);

  // function to get the search result

  useEffect(() => {
    const storedIds = localStorage.getItem("StatusHelp");
    if (storedIds) {
      const idsArray = storedIds.split(',').map(id => id.trim());
      const initialSelectedOptions = idsArray
        .map(id => {
          const status = complaintStatusList.find(item => item.statusId === Number(id));
          return status ? { value: status.statusId, label: status.statusName } : null;
        })
        .filter(Boolean);
      setSelectedOptions(initialSelectedOptions);
      console.log("JSON REQ Intial", initialSelectedOptions);
    }

  }, [complaintStatusList]);

  async function SearchComplaint(page = 0) {
    let buildingId;
    let userData = localStorage.getItem("userData");
    if (userData) {
      userData = JSON.parse(userData);
      buildingId = userData.buildingId;
    }
    let endPointVariableKey = { buildingId };
    const statusIds = selectedOptions.map(option => option.value).join(',') || null;
    const statusCategory = selectedCategories.map(option => option.value).join(',') || null;
    const statusStaff = selectedStaff.map(option => option.value).join(',') || null;
    const JSONRequest = {
      "flatId": flatListId || null,
      "towerId": towerId || null,
      "categoryId": statusCategory || null,
      "statusId": statusIds || null,
      "assignedTo": statusStaff || null,
      "isUrgent": isUrgent === "null" ? null : isUrgent,
      "startDate": startDate || null,
      "endDate": endDate || null,
      "applicableLevel": AppLevel || null,
      "pageNumber": page,
      "pageSize": 20
    }
    console.log("JSON REQ", JSONRequest, statusIds, selectedOptions);
    try {
      if (page === 0) {
        setLoading(true);
      } else {
        if (complaintLoadingMoreRef.current || !hasMoreComplaints) return;
        complaintLoadingMoreRef.current = true;
        setComplaintLoadingMore(true);
      }

      const response = await commonAPI("GetComplaintPOST", JSONRequest, endPointVariableKey);
      setShow8(false)
      console.log("response GetComplaintPOST", response);

      if (response?.success && !response.message.length) {
        const newData = response.data || [];
        setComplaintList((prev) => (page === 0 ? newData : [...prev, ...newData]));

        // Continue while the API returns a complete page.
        setHasMoreComplaints(newData.length >= 20);
        setComplaintPage(page);
        setAdvanceShow(false)
      } else if (!response?.success && response.message.length) {
        toast.error(response.message[0]);
        if (page === 0) setComplaintList([]);
      }
    } catch (error) {
      ErrorLog(userData.userId, userData.mobileNumber, JSONRequest, "GetComplaint", "HD01", error.message, error, "HelpDesk.js", "SearchComplaint");
      toast.error("Something went wrong, Please try again after some time");
    } finally {
      setLoading(false);
      complaintLoadingMoreRef.current = false;
      setComplaintLoadingMore(false);
      setShow8(false);
    }
  }

  function showReopenBtn(item) {
    console.log("i called here")
    try {

      if (ReopenHourSetting) {

        console.log("i called here")

        const complainResolveDate = moment(item.resolvedDt).format('YYYY-MM-DD HH:mm:ss');
        const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');
        const isocomplainCreatedDate = moment(item.resolvedDt)
        const isoCurrentTime = moment()
        console.log(currentTime, isoCurrentTime, "CurrentTime");
        console.log(complainResolveDate, isocomplainCreatedDate, "CurrentTime");
        const differenceInHours = isoCurrentTime.diff(isocomplainCreatedDate, 'hours');

        console.log(differenceInHours, "DISS")
        // console.log(complainSetting.COMPLAINT_REOPEN_TIME_IN_HOURS)
        if (differenceInHours <= ReopenHourSetting) {
          setShowReopenBtn(false)
        }
        else {
          setShowReopenBtn(true)
        }
      }
      else {
        toast.error("Something went wrong, Please try again after some time");
      }

    }
    catch (error) {
      console.log(error)
    }
  }

  async function getComplaint(page = 0) {
    let buildingId;
    let userData = localStorage.getItem("userData");
    if (userData) {
      userData = JSON.parse(userData);
      buildingId = userData.buildingId;
    }
    let endPointVariableKey = { buildingId };
    let requestBody = {
      pageNumber: page,
      pageSize: 20,
    };
    try {
      if (page === 0) {
        setLoading(true);
      } else {
        if (complaintLoadingMore || !hasMoreComplaints) return;
        setComplaintLoadingMore(true);
      }

      const response = await commonAPI("GetComplaint", requestBody, endPointVariableKey);
      if (response?.success && !response.message.length) {
        const newData = response.data || [];
          setComplaintList((prev) => (page === 0 ? newData : [...prev, ...newData]));
          setHasMoreComplaints(newData.length >= 20);
        setComplaintPage(page);
      } else if (!response?.success && response.message.length) {
        toast.error(response.message[0]);
      }
    } catch (error) {
      ErrorLog(userData.userId, userData.mobileNumber, null, "GetComplaint", "HD02", error.message, error, "HelpDesk.js", "getComplaint");
      toast.error("Something went wrong, Please try again after some time");
    } finally {
      setLoading(false);
      setComplaintLoadingMore(false);
    }
  }
  const handleComplaintScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (
      scrollTop + clientHeight >= scrollHeight - 50 &&
      !complaintLoadingMoreRef.current &&
      hasMoreComplaints
    ) {
      SearchComplaint(complaintPage + 1);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      await SearchComplaint(); // Wait for SearchComplaint to complete
    };
    if (selectedOptions.length > 0) {
      fetchData();
    }
  }, [selectedOptions]);

  async function handleComplaintById(item) {
    let buildingId;
    let userData = localStorage.getItem("userData");
    if (userData) {
      userData = JSON.parse(userData);
      buildingId = userData.buildingId;
    }
    let endPointVariableKey = { buildingId, urlVariable: item.complaintId };
    try {
      setLoading(true);
      const response = await commonAPI("ComplaintById", undefined, endPointVariableKey);
      console.log("response for complaintDetails", response, endPointVariableKey)
      if (response?.success && !response.message.length) {
        setComplaintDetails(response.data);
        setComplaintImageList(response.data.complaintImageList);
      } else if (!response?.success && response.message.length) {
        toast.error(response.message[0]);
      }
    } catch (error) {
      ErrorLog(userData.userId, userData.mobileNumber, null, "ComplaintById", "HD03", error.message, error, "HelpDesk.js", "handleComplaintById");
      toast.error("Something went wrong, Please try again after some time");
    } finally {
      setLoading(false);
    }

  }
  const CloseModal = () => {
    setShow1(false);
    compaintStateCleaner();
  }
  function handleTowerChange(e) {
    setTowerId(parseInt(e.target.value));
  }

  function handleFlatChange(e) {
    setFlatListId(parseInt(e.target.value))
  }
  function handleUrgencyChange(e) {
    setIsUrgent(() => e.target.value === "true" ? true : e.target.value === "false" ? false : "null");
  }
  // function handleCategoryChange(e) {
  //   setCategoryId(parseInt(e.target.value));
  // }
  function handleServiceStaffChange(e) {
    setServiceStaffId(parseInt(e.target.value));
  }

  // function handleStatusChange(e) {
  //   setStatusId(e.target.value);;
  // }

  function handleServiceStaffSelect(e) {
    setServiceStaffIdComplainee(parseInt(e.target.value));
  }

  function handleTowerSelect(e) {
    setResidentId("");
    setResidentList([]);
    setFlatComplaineeId("");
    setFlatListComplainee([]);
    setTowerIdComplainee(parseInt(e.target.value));
  }

  function handleFlatSelect(e) {
    setFlatComplaineeId(parseInt(e.target.value));
    setResidentId("");
    setResidentList([]);
  }

  function handleETADateSelect(e) {
    setETADate(e.target.value);
  }

  function clearFilter() {
    setTowerId("");
    setCategoryId("");
    setStatusId("");
    setFlatListId("");
    setServiceStaffId("");
    setIsUrgent("null");
    setFlatList([]);
    setSelectedOptions([]);
    setSelectedCategories([]);
    setSelectedStaff([]);
    setStartDate("");
    setEndDate("");
    localStorage.removeItem("StatusHelp");
    localStorage.removeItem("UrgentStats");
    localStorage.removeItem("TodayStartDate");
    localStorage.removeItem("TodayEndDate");
    localStorage.removeItem("SocietyLevel");
  }

  useEffect(() => {
    if (
      !towerId &&
      !categoryId &&
      !statusId &&
      !flatListId &&
      !serviceStaffId &&
      isUrgent === "null" &&
      selectedOptions.length === 0 &&
      selectedCategories.length === 0 &&
      selectedStaff.length === 0 &&
      !startDate &&
      !endDate
    ) {
      SearchComplaint();
    }
  }, [
    towerId,
    categoryId,
    statusId,
    flatListId,
    serviceStaffId,
    isUrgent,
    selectedOptions,
    selectedCategories,
    selectedStaff,
    startDate,
    endDate,
  ]);

  function handleCategorySelect(e) {
    allowChange.current = true;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const categoryId = parseInt(e.target.value);
    const categoryName = selectedOption.text;

    setCategoryIdComplainee(categoryId);
    setCategoryNameComplainee(categoryName)
    setSubCategoryId("");
    setSubCategoryList([]);
  }

  function handleSubcategorySelect(e) {

    const selectedOption = e.target.options[e.target.selectedIndex];
    const categoryId = parseInt(e.target.value);
    const categoryName = selectedOption.text;
    setSubCategoryNameComplainee(categoryName)
    setSubCategoryId(categoryId);
  }

  function handleRequestTypeSelect(e) {
    setRequestType(e.target.value);
  }
  function handleIsUrgentSelect(e) {
    console.log("e.target.value", e.target.value)
    // setIsUrgentComplainee(() => e.target.value === "true" ? true : false);
    setIsUrgentComplainee((prevState) => !prevState)
    console.log("IsUrgentComplainee", isUrgentComplainee)
  }

  function handleStatusSelect(e) {
    const selectedOption = e.target.options[e.target.selectedIndex];
    setStatusName(selectedOption.text.toUpperCase());
    setComplaintStatusId(parseInt(e.target.value));;
    if (selectedOption.text.toUpperCase() === "REOPEN" || selectedOption.text.toUpperCase() === "ONHOLD") {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
      setReasonId("")
    }
  }

  function handleReasonSelect(e) {
    const selectedOption = e.target.options[e.target.selectedIndex];
    // setStatusName(selectedOption.text.toUpperCase());
    setReasonId(parseInt(e.target.value));
  }

  function handleUserSelect(e) {
    setResidentId(parseInt(e.target.value));
  }

  const handleComplaineeFileSelect = (event, index) => {
    console.log("index is", index);
    const file = event.target.files[0];

    if (file) {
      const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        alert("Only JPG, JPEG, and PNG files are allowed.");
        return;
      }

      // Get file properties
      const fileName = file.name;
      const fileSize = (file.size / 1024).toFixed(2);
      const fileExtension = fileName.split('.').pop();

      // Convert file to Base64
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result;

        // Create the object
        const fileObject = {
          fileName,
          fileSize,
          fileExtension,
          base64String,
        };

        // Update the base64img array
        const tempArr = [...base64img];
        tempArr[index] = fileObject;
        setBase64img(tempArr);
      };
      reader.readAsDataURL(file);
    }
  };

  function handleCommentSet(e) {
    setUserComment(e.target.value);
  }

  // clean the states for update complaint modal
  const compaintStateCleaner = () => {
    setRequestType("");
    setLines([])
    allowChange.current = null;
    setIsDisabled(true);
    // setTowerId("");
    setTowerIdComplainee("");
    setFlatComplaineeId("");
    setFlatListComplainee([]);
    setResidentId("");
    setResidentList([]);
    setComplaintDesc("");
    setIsUrgentComplainee(false);
    setCategoryIdComplainee("");
    setSubCategoryId("");
    setCategoryNameComplainee("");
    setSubCategoryNameComplainee("");
    setServiceStaffIdComplainee("");
    setComplaintDetails(null);
    setBase64img([]);
    setUserComment("");
    setETADate(null);
  }

  async function addComplaint() {
    if (!requestType) {
      toast.error("Please select request type");
      return;
    }

    if (requestType === "PERSONAL" && !towerIdComplainee) {
      toast.error("For personal request type tower selection is mandatory");
      return;
    }

    if (requestType === "PERSONAL" && !flatComplaineeId) {
      toast.error("For personal request type flat selection is mandatory");
      return;
    }

    if (requestType === "PERSONAL" && !residentId) {
      toast.error("For personal request type user selection is mandatory");
      return;
    }
    if (!categoryIdComplainee) {
      toast.error("Please select compalint category");
      return;
    }
    if (!complaintDesc) {
      toast.error("Please write complaint description");
      return;
    }
    let buildingId;
    let userData = localStorage.getItem("userData");
    if (userData) {
      userData = JSON.parse(userData);
      buildingId = userData.buildingId;
    }
    let endPointVariableKey = { buildingId };

    let imageData = base64img.filter((item) => item != undefined);
    const complaintImages = imageData.map((item) => {
      return ({
        "createdUserId": userData.userId.toString(),
        "originalFileName": item.fileName,
        "fileExt": item.fileExtension,
        "imageBase64Data": item.base64String,
        "imageType": "CREATED"
      })
    })
    // console.log("imageData is", complaintImages);
    const JSONRequest = {
      "complaintData": {
        "createdUserId": userData.userId.toString(),
        "complaintDesc": complaintDesc,
        "isUrgent": isUrgentComplainee,
        "categoryId": categoryIdComplainee || null,
        "subCategoryId": subCategoryId || null,
        "userMappingId": residentId || null,
        "applicableLevel": requestType,
        "complaintTitle": subCategoryId ? `${categoryNameComplainee}/${subCategoryNameComplainee}` : categoryNameComplainee,
        "assignedTo": serviceStaffIdComplainee || null,
        "complaintCreatedBy": userData.userName
      },
      "complaintImages": complaintImages
    }
    console.log("json Request is", JSONRequest)
    try {
      setLoading(true);
      const response = await commonAPI("RaiseComplaint", JSONRequest, endPointVariableKey);
      if (response?.success && !response.message.length) {
        getComplaint();
        compaintStateCleaner();
        setShow(false);
        setAdvanceShow(false);
      } else if (!response?.success && response.message.length) {
        toast.error(response.message[0]);
      }
      console.log("response for complaint is", response);
    } catch (error) {
      ErrorLog(userData.userId, userData.mobileNumber, JSONRequest, "Complaint", "HD04", error.message, error, "HelpDesk.js", "AddComplaint");
      toast.error("Something went wrong, Please try again after some time");
    } finally {
      setLoading(false);

    }
  }

  async function updateComplaint() {
    if (!requestType) {
      toast.error("Please select request Type");
      return;
    }

    if (requestType === "PERSONAL" && !towerIdComplainee) {
      toast.error("For personal request type tower selection is mandatory");
      return;
    }

    if (requestType === "PERSONAL" && !flatComplaineeId) {
      toast.error("For personal request type flat selection is mandatory");
      return;
    }

    if (requestType === "PERSONAL" && !residentId) {
      toast.error("For personal request type user selection is mandatory");
      return;
    }

    if (!categoryIdComplainee) {
      toast.error("Please select compalint category");
      return;
    }
    if (!ETAdate) {
      toast.error("Please select expected turn around time");
      return;
    }
    if (statusName.toUpperCase() === "OPEN" && serviceStaffIdComplainee) {
      toast.error("Status cannot be set open in case of a person is assigned");
      return;
    }

    if (statusName.toUpperCase() === "ONHOLD" && !reasonId) {
      toast.error("Please provide a reason to keep the complaint on hold");
      return;
    }

    if (statusName.toUpperCase() === "REOPEN" && !reasonId) {
      toast.error("Please provide a reason to reopen the complaint");
      return;
    }

    let buildingId;
    let userData = localStorage.getItem("userData");
    if (userData) {
      userData = JSON.parse(userData);
      buildingId = userData.buildingId;
    }


    let endPointVariableKey = { buildingId };
    // console.log("imageData is", complaintImages);
    const JSONRequest = {
      "modifiedUserId": userData.userId.toString(),
      "complaintId": complaintDetails.complaintId ? parseInt(complaintDetails.complaintId, 10) : null,
      "isUrgent": isUrgentComplainee,
      "categoryId": categoryIdComplainee || null,
      "subCategoryId": subCategoryId || null,
      "applicableLevel": requestType,
      "complaintTitle": subCategoryId ? `${categoryNameComplainee}/${subCategoryNameComplainee}` : categoryNameComplainee,
      "assignedTo": serviceStaffIdComplainee || null,
      "statusId": complaintStatusId || null,
      "complaintCreatedBy": userData.userName,
      "userMappingId": residentId || null,
      "eta": ETAdate,
      "holdReasonId": statusName === "ONHOLD" ? reasonId : null,
      "reopenedReasonId": statusName === "REOPEN" ? reasonId : null
    }
    console.log("json Request is", JSONRequest);
    try {
      setLoading(true);
      const response = await commonAPI("updateComplaint", JSONRequest, endPointVariableKey);
      if (response?.success && !response.message.length) {
        handleComplaintById(complaintDetails);
        getComplaint();
        setShow2(false);
        setAdvanceShow(false)
      } else if (!response?.success && response.message.length) {
        toast.error(response.message[0]);
      }
      console.log("response for update is", response);
    } catch (error) {
      ErrorLog(userData.userId, userData.mobileNumber, JSONRequest, "Complaint", "HD05", error.message, error, "HelpDesk.js", "updateComplaint");
      toast.error("Something went wrong, Please try again after some time");
    } finally {
      setLoading(false);

    }
  }

  async function PostComments() {
    if (!userComment) {
      toast.error("Please write a comment first");
      return;
    }

    let buildingId;
    let userData = localStorage.getItem("userData");
    if (userData) {
      userData = JSON.parse(userData);
      buildingId = userData.buildingId;
    }
    let endPointVariableKey = { buildingId };
    let usercom = userData.userName;
    let date = convertDate_(new Date());
    usercom = `${usercom} ${date} ${userComment}`
    // console.log("imageData is", complaintImages);
    const JSONRequest = {
      "modifiedUserId": userData.userId.toString(),
      "complaintId": complaintDetails.complaintId ? parseInt(complaintDetails.complaintId, 10) : null,
      "comments": usercom,
    }

    console.log("json Request comment is", JSONRequest)
    try {
      setLoading(true);
      const response = await commonAPI("ComplaintComments", JSONRequest, endPointVariableKey);
      if (response?.success && !response.message.length) {
        handleComplaintById(complaintDetails);
        setUserComment("");
      } else if (!response?.success && response.message.length) {
        toast.error(response.message[0]);
      }
      console.log("response for comment is", response);
    } catch (error) {
      ErrorLog(userData.userId, userData.mobileNumber, JSONRequest, "ComplaintComments", "HD06", error.message, error, "HelpDesk.js", "PostComments");
      toast.error("Something went wrong, Please try again after some time");
    } finally {
      setLoading(false);

    }
  }

  // api call when page is mounted

  useEffect(() => {
    let buildingId;
    let userData = localStorage.getItem("userData");
    if (userData) {
      buildingId = JSON.parse(userData).buildingId;
    }
    let endPointVariableKey = { buildingId };
    let requestBody = {
      pageNumber: 0,
      pageSize: 20,
    };
    const manageLoading = (isLoading) => setLoading(isLoading);
    async function fetchData() {
      manageLoading(true);
      try {
        const towerPromise = commonAPI("Tower", undefined, endPointVariableKey);
        const statusPromise = commonAPI("ComplaintStatus", undefined, endPointVariableKey);
        const ComplaintCategoryPromise = commonAPI("ComplaintCategory", undefined, endPointVariableKey)
        const staffPromise = commonAPI("GetServiceStaff", {}, endPointVariableKey);
        const complaintPromise = commonAPI("GetComplaint", requestBody, endPointVariableKey);
        const reasonPromise = commonAPI("Reason", undefined, endPointVariableKey);

        const [towerResponse, statusResponse, ComplaintCategoryResponse, staffResponse, complaintResponse, reasonResponse] = await Promise.all([
          towerPromise,
          statusPromise,
          ComplaintCategoryPromise,
          staffPromise,
          complaintPromise,
          reasonPromise
        ]);

        if (towerResponse?.success && !towerResponse?.message?.length) {
          console.log("Tower Response", towerResponse);
          setTowerList(towerResponse?.data);
        } else {
          toast.error("Something went wrong, Please try again after some time");
        }

        if (statusResponse?.success && !statusResponse?.message?.length) {
          console.log("ComplaintStatus Response", statusResponse);
          setComplaintStatusList(statusResponse?.data);
        } else {
          toast.error("Something went wrong, Please try again after some time");
        }

        if (staffResponse?.success && !staffResponse?.message?.length) {
          console.log("GetServiceStaff Response", staffResponse);
          setServiceStaffList(staffResponse?.data);
        } else {
          toast.error("Something went wrong, Please try again after some time");
        }

        if (complaintResponse?.success && !complaintResponse?.message?.length) {
          console.log("GetComplaint Response", complaintResponse);
          // setComplaintList(complaintResponse.data);
        } else {
          toast.error("Something went wrong, Please try again after some time");
        }
        if (ComplaintCategoryResponse?.success && !ComplaintCategoryResponse?.message?.length) {
          console.log("ComplaintCategory Response", ComplaintCategoryResponse);
          setCategoryList(ComplaintCategoryResponse?.data);
        } else {
          toast.error("Something went wrong, Please try again after some time");
        }
        if (reasonResponse?.success && !reasonResponse?.message?.length) {
          console.log("Reason Response", reasonResponse);
          setReasonList(reasonResponse?.data);
        } else {
          toast.error("Something went wrong, Please try again after some time");
        }
      } catch (error) {
        console.error("Error fetching data", error);
        ErrorLog(userData.userId, userData.mobileNumber, undefined, "Tower", "HD13", error.message, JSON.stringify(error), "HelpDesk.js", "UseEffect");
        toast.error("Something went wrong, Please try again after some time");
      } finally {
        manageLoading(false);
      }
    }
    fetchData();
  }, []);



  // getting flatList based on the towerId

  useEffect(() => {
    const fetchData = async () => {
      if (towerId) {
        // setFlatListId("");
        // setFlatList([]);
        let buildingId;
        let userData = localStorage.getItem("userData");
        if (userData) {
          buildingId = JSON.parse(userData).buildingId;
        }
        let endPointVariableKey = { buildingId };
        try {
          // setLoading(true);
          let response = await commonAPI("Flat", undefined, endPointVariableKey);
          if (response?.success === true) {
            const tempData = response?.data.filter((item) => item?.towerId == towerId);
            setFlatList(tempData);
          } else {
            toast.error("Something went wrong");
          }
        } catch (error) {
          ErrorLog(userData.userId, userData.mobileNumber, undefined, "Flat", "HD12", error.message, error, "HelpDesk.js", "UseEffect");
          toast.error("Something went wrong, Please try again after some time");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData(); // Call the async function
  }, [towerId]);

  useEffect(() => {
    const fetchData = async () => {
      if (towerIdComplainee) {
        let buildingId;
        let userData = localStorage.getItem("userData");
        if (userData) {
          buildingId = JSON.parse(userData).buildingId;
        }
        let endPointVariableKey = { buildingId };
        try {
          // setLoading(true);
          let response = await commonAPI("Flat", undefined, endPointVariableKey);
          if (response?.success === true) {
            const tempData = response?.data.filter((item) => item?.towerId == towerIdComplainee);
            setFlatListComplainee(tempData);
          } else {
            toast.error("Something went wrong");
          }
        } catch (error) {
          ErrorLog(userData.userId, userData.mobileNumber, undefined, "Flat", "HD12", error.message, error, "HelpDesk.js", "UseEffect");
          toast.error("Something went wrong, Please try again after some time");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData(); // Call the async function
  }, [towerIdComplainee]);

  useEffect(() => {
    const fetchData = async () => {
      if (towerIdComplainee) {
        // setFlatComplaineeId("");
        // setFlatListComplainee([]);
        let buildingId;
        let userData = localStorage.getItem("userData");
        if (userData) {
          buildingId = JSON.parse(userData).buildingId;
        }
        let endPointVariableKey = { buildingId };
        try {
          // setLoading(true);
          let response = await commonAPI("Flat", undefined, endPointVariableKey);
          if (response?.success === true) {
            const tempData = response?.data.filter((item) => item?.towerId == towerIdComplainee);
            setFlatListComplainee(tempData);
          } else {
            toast.error("Something went wrong");
          }
        } catch (error) {
          ErrorLog(userData.userId, userData.mobileNumber, undefined, "Flat", "HD13", error.message, error, "HelpDesk.js", "UseEffect");
          toast.error("Something went wrong, Please try again after some time");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchData();
  }, [towerIdComplainee]);

  useEffect(() => {
    if (categoryIdComplainee) {
      try {
        // if (allowChange.current) {
        //   setSubCategoryId(null);
        // }
        setSubCategoryList([]);
        let data = categoryList.filter((item) => item.categoryId == categoryIdComplainee);
        console.log("data is", data);
        if (data?.length) {
          setSubCategoryList(data[0].subCategory);
        }
      } catch (error) {
      }
    }
  }, [categoryIdComplainee]);



  useEffect(() => {
    if (flatComplaineeId) {
      const GetParentList = async () => {
        const auth = localStorage.getItem("userData");
        const myUserData = JSON.parse(auth);

        const bodyData = {
          "buildingId": myUserData?.buildingId,
          "towerId": towerIdComplainee,
          "flatId": flatComplaineeId,
          "isResiding": true,
        }

        try {
          // setLoading(true);
          let response = await commonAPI("GetCuroNextUserMapping", bodyData);
          console.log("response for user is", response, bodyData);
          if (response.success == true && response.message.length == 0) {
            setResidentList(response?.data);
            if (response.data.length === 1) {
              setResidentId(parseInt(response.data[0].userMappingId))
            }
          } else if (!response.success && response.message.length) {
            toast.error(response.message[0]);
          }

        } catch (error) {
          ErrorLog(myUserData.userId, myUserData.mobileNumber, bodyData, "GetCuroNextUserMapping", "HD14", error.message, error, "HelpDesk.js", "UseEffect");
          toast.error("Something went wrong, Please try again after some time");
        } finally {
          setLoading(false);
        }

      }
      GetParentList();
    }

  }, [flatComplaineeId]);

  useEffect(() => {
    if (complaintDetails) {
      setRequestType(complaintDetails.applicableLevel?.toUpperCase() || "");
      setCategoryIdComplainee(complaintDetails.categoryId || "");
      setSubCategoryId(complaintDetails.subCategoryId || "");
      setIsUrgentComplainee(complaintDetails.isUrgent);
      setServiceStaffIdComplainee(complaintDetails.assignedTo || "");
      setComplaintStatusId(complaintDetails.statusId || "");
      setReasonId(complaintDetails.reasonId || "");
      setCategoryNameComplainee(complaintDetails.categoryName);
      setSubCategoryNameComplainee(complaintDetails.subCategoryName);
      setTowerIdComplainee(complaintDetails.towerId || "");
      setFlatComplaineeId(complaintDetails.flatId || "");
      setResidentId(complaintDetails.userMappingId || "");
      setStatusName(complaintDetails.statusName);
      setReasonId(complaintDetails.holdReasonId || complaintDetails.reopenedReasonId || "");
      if (complaintDetails.statusName.toUpperCase() === "REOPEN" || complaintDetails.statusName.toUpperCase() === "ONHOLD") {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
        setReasonId("")
      }
      if (complaintDetails.eta) {
        const formatedTime = complaintDetails.eta?.slice(0, 16);
        if (formatedTime) {
          setETADate(formatedTime);
        } else {
          setETADate(null);
        }
        // const date = new Date(complaintDetails.eta);
        // const year = date.getFullYear();
        // const month = String(date.getMonth() + 1).padStart(2, "0");
        // const day = String(date.getDate()).padStart(2, "0");
        // setETADate(`${year}-${month}-${day}`);
        // setETADate(complaintDetails.eta);
      }
    }
    let tempLine = complaintDetails?.comments
    if (tempLine) {
      const commentArr = tempLine.split("\r");
      if (commentArr.length) {
        setLines(commentArr);
      }
    }

    setCompRating(complaintDetails?.serviceRating || 0)

  }, [complaintDetails])



  const handleChange = (selected) => {
    setSelectedOptions(selected);
    // const selectedValues = selected.map(option => option.value).join(',');
    // localStorage.setItem("StatusHelp", selectedValues);
  };

  const options = complaintStatusList.map(item => ({
    value: item.statusId,
    label: item.statusName
  }));

  const towerOptions = towerList
    ? towerList.map(item => ({
      value: item.towerId,
      label: item.towerName ? String(item.towerName) : 'Unnamed',
    }))
    : [];

  const flatOptions = flatList
    ? flatList.map(item => ({
      value: item.flatId,
      label: item.flatName ? String(item.flatName) : 'Unnamed',
    }))
    : [];

  console.log("flatOptions", flatOptions, towerId)

  console.log("StatsTodayStart StatsEndStart", StatsTodayStart, convertDate(StatsEndStart));


  return (
    <>
      {loading ?
        <div className="loaderDiv">
          <div className="loader"></div>
        </div>
        : null}

      <ToastContainer />
      <style>
        {`.table-responsive {
              height: ${slideshowHeight}px;
              overflow-y: auto;
              background-color: #f8f9fa;
          }
         
        `}
      </style>
      <div className="row mb-1">
        <div className="col-md-6 mt-5 pt-2">
          <div className="HeadingTop">
            <h3>Helpdesk</h3>
            <span style={{ whiteSpace: "nowrap" }}>
              {/* Provide a structured platform for residents to raise complaints. */}
              Platform for residents to raise complaints.
            </span>
          </div>
        </div>
        <div className="col-md-6 text-right mt-5 pt-5">
          {/* Wrapper for dropdowns: Creates stacking context and prevents clipping */}
          <div
            className="dropdown-wrapper"
            style={{
              position: 'relative',
              zIndex: 999, // High base z-index
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              gap: '10px',
              overflow: 'visible', // Allow dropdown to overflow parent
            }}
          >
            <Button
              className="createClr"
              style={{}}
              onClick={() => setShowEscalationModal(true)}
            >
              Escalation
            </Button>
            <SelectSearch
              searchable={true}
              clearable={towerId ? true : false}  // ✅ FIXED: Check string value
              options={towerOptions}
              labelField="label"
              valueField="value"
              className=""
              placeholder="Select Tower"
              values={
                towerId
                  ? towerOptions.filter((option) => option.value === towerId)  // ✅ FIXED: Remove [0]
                  : []
              }
              onChange={(selectedOptions) => {
                if (selectedOptions && selectedOptions.length > 0) {
                  setTowerId(selectedOptions[0].value);
                  setFlatListId("");
                  setFlatList([]);
                } else {
                  setTowerId("");
                  setFlatListId("");
                  setFlatList([]);
                }
              }}
              searchBy="label"
              menuPortalTarget={document.body}
              menuPlacement="auto"
              minMenuHeight={200}
              style={{
                fontSize: '13px',
                borderColor: '#ccc',
                borderRadius: '4px',
                height: '39px',
                width: '150px',
                backgroundColor: '#fff',
                textAlign: 'left',
                marginRight: 0,
              }}
              dropdownStyle={{
                width: '150px',
                zIndex: 10001,
                position: 'absolute',
                left: 0,
                right: 0,
                margin: 0,
                borderTop: 'none',
              }}
            />


            <SelectSearch
              searchable={true}
              clearable={flatListId ? true : false}
              options={flatOptions}
              labelField="label"
              valueField="value"
              className="sltareamodal"
              placeholder="Select Flat"
              values={
                flatList && flatListId
                  ? flatList
                    .filter((item) => item.flatId === flatListId)
                    .map((item) => ({ value: item.flatId, label: item.flatName }))
                  : []
              }
              onChange={(selectedOptions) => {
                if (selectedOptions && selectedOptions.length > 0) {
                  setFlatListId(Number(selectedOptions[0].value));
                } else {
                  setFlatListId("");
                }
              }}
              searchBy="label"
              menuPortalTarget={document.body}
              menuPlacement="auto"
              minMenuHeight={200}
              style={{
                fontSize: '13px',
                borderColor: '#ccc',
                borderRadius: '4px',
                height: '39px',
                width: '150px',
                backgroundColor: '#fff',
                textAlign: 'left',
                marginRight: 0,
              }}
              dropdownStyle={{
                width: '150px',
                zIndex: 10001,
                position: 'absolute',
                left: 0,
                right: 0,
                margin: 0,
                borderTop: 'none',
              }}
            />


            {/* Your existing select and buttons (unchanged) */}
            <select
              size="md"
              className="sltareamodal hdesk ml-auto bg-white"
              onChange={handleUrgencyChange}
              value={isUrgent}
              style={{
                WebkitAppearance: 'none', // Safari reset for native select
                appearance: 'none',
                padding: '0.375rem 0.75rem', // Consistent padding
              }}
            >
              <option value="null">Urgent</option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </select>

            <Button
              className="createClr bg-white border-1"
              style={{ padding: 6 }}
              onClick={() => setAdvanceShow((prevState) => !prevState)}
            >
              <img
                src={AdvanceShow ? UpImage : DownImage}
                className="img"
                style={{
                  width: "20px",
                  filter:
                    "brightness(0) saturate(100%) invert(68%) sepia(26%) saturate(636%) hue-rotate(142deg) brightness(92%) contrast(85%)",
                }}
              />
            </Button>

            <Button className="createClr" style={{}} onClick={SearchComplaint}>
              Search
            </Button>

            <Button className="createClr" style={{}} onClick={() => clearFilter()}>
              Reset
            </Button>

            <Button className="createClr" onClick={() => setShow(true)}>
              Raise Complaint
            </Button>
          </div>
        </div>
      </div>


      <div className={`row mb-3 transitionAdvance ${AdvanceShow ? 'showAdvance' : ''}`} style={{ justifyContent: "end", paddingTop: 10, paddingBottom: 10, alignItems: 'center', height: "auto", position: 'absolute', width: "100%", backgroundColor: "#fff", zIndex: 9, borderRadius: 9, top: 150 }}>
        <div className='col-3'>
          <Select
            isMulti
            placeholder="Status"
            options={options}
            onChange={handleChange}
            value={selectedOptions}
            className="d-inline-block ml-auto w-100"
          />
        </div>
        <div className='col-3'>
          <Select
            isMulti
            placeholder="Category"
            options={optionsCategory}
            onChange={handleCategoryChange}
            value={selectedCategories}
            className="d-inline-block ml-auto w-100"
          />
        </div>
        <div className='col-3'>
          <Select
            isMulti
            placeholder="Assigned"
            options={optionsStaff}
            onChange={handleChangeStaff}
            value={selectedStaff}
            className="d-inline-block ml-auto w-100"
          />
        </div>
        {/* <div className='col-2'>
          <select onChange={handleTowerChange} size="md" className="help__annonymus__btn ml-auto bg-white" value={towerId} >
            <option value="">Tower</option>
            {towerList.map((item, index) => {
              return (

                <option key={index} value={item.towerId}>{item.towerName}</option>
              )
            })}

          </select>{" "}
        </div>  
        <div className='col-2'>
          <select size="md" className="help__annonymus__btn ml-auto bg-white" onChange={handleFlatChange} value={flatListId}>
            <option value="">Flat</option>
            {flatList.map((item, index) => {
              return (
                <option key={index} value={item.flatId}>{item.flatName}</option>
              )
            })}
          </select>{" "}
        </div>   */}
        {/* <div className='col-2'>
          <Button className="createClr" style={{}} onClick={SearchComplaint}>
            Search
          </Button>
          <Button className="btn border bg-white" style={{}} onClick={() => setAdvanceShow(false)}>
            Cancel
          </Button>
        </div> */}
      </div>

      <div className="row mb-3" style={{ alignItems: 'center' }}>
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <div className="tableFixHead">
            <div
              className="scrolling_tbl"
              style={{ height: `${slideshowHeight}px`, overflowY: "auto" }}
              onScroll={handleComplaintScroll}
            >
              <Table striped>
                <thead>
                  <tr>

                    <th className='nopd'>Req#</th>
                    <th className='nopd'> Type </th>
                    <th className='nopd'>Category / Sub-Category</th>
                    <th className='nopd'>Tower</th>
                    <th className='nopd'>Flat</th>
                    <th className='nopd'>Urgent</th>
                    <th className='nopd'>Created Date</th>
                    <th className='nopd'>Closure Date</th>
                    <th className='nopd'>Status</th>
                    <th className='nopd'>Assigned to</th>
                    <th className='nopd'>Aging</th>
                    <th className='nopd'>ETA</th>
                    <th className='nopd'>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {compaintList.length === 0 && loading ? (
                    <tr>
                      <td colSpan="13" className="text-center py-4">
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Loading requests...
                      </td>
                    </tr>
                  ) : compaintList.length === 0 && !loading ? (
                    <tr>
                      <td colSpan="13" className="text-center py-4">
                        No records found
                      </td>
                    </tr>
                  ) : (
                    compaintList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td className='nodt'>{item.complaintId}</td>
                          <td className='nodt'>{item.applicableLevel}</td>
                          {item.subCategoryName ? <td className='expectednodt'> <p>{item.categoryName}/{item.subCategoryName}</p></td> : <td className='expectednodt'> <p>{item.categoryName}</p></td>}
                          <td className='nodt'>{item.towerName}</td>
                          <td className='nodt'>{item.flatName}</td>
                          <td className='nodt'>{item.isUrgent ? "Yes" : "No"}</td>
                          <td className='nodt'>{convertDate(item?.createdDt)}</td>
                          <td className='nodt'>{convertDate(item?.resolvedDt)}</td>
                          <td className='nodt'>{item.statusName}</td>
                          <td className='expectednodt' title="">
                            <p>{item.ssName}</p>
                          </td>
                          <td className='nodt'>{item.aging}</td>
                          <td className="nodt"> {convertDate_(item.eta)} </td>
                          <td className='nodt'> <Link href="#" onClick={() => {
                            setShow1(true);
                            handleComplaintById(item);
                            showReopenBtn(item)
                          }} >  Edit </Link></td>
                        </tr>
                      )
                    })
                  )}

                  {complaintLoadingMore && compaintList.length > 0 && (
                    <tr>
                      <td colSpan="13" className="text-center">
                        <div className="py-2">
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Loading more...
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>

              </Table>

            </div>
          </div>

        </div>
      </div>

      <Modal show={show} onHide={() => {
        setShow(false);
        compaintStateCleaner();
      }
      } size='lg' className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
        <div style={{ width: "757px" }}>
          <Modal.Header closeButton className='headerMDL'>
            <Modal.Title id="example-custom-modal-styling-title"> Raise Complaint</Modal.Title>
          </Modal.Header>
          <Modal.Body className="helpingElelemnt_helpdesk" style={{ width: "auto", paddingBottom: '0px' }}>

            <div className="row" id="validation">
              <div className="col-md-5">
                <div className="form-group text-left">
                  <label for="wlastName"> Request Type <span className="danger">*</span>  </label>
                  <div className="form-group text-left d-flex justify-content-between">
                    <input type="radio" id="unit" name="fav_language" value="PERSONAL" onChange={handleRequestTypeSelect} checked={requestType === "PERSONAL"} />
                    <label for="unit" className="mb-0">Personal Level</label><br />

                    <input type="radio" id="urgent" name="fav_language" value="SOCIETY" onChange={handleRequestTypeSelect} checked={requestType === "SOCIETY"} />
                    <label for="urgent" className="mb-0"> Society Level</label><br />

                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div className="row">
                  <div className="col-md-6 ">

                    <div className="form-group text-left mt-2">
                      <label for="wfirst"> Tower {requestType === "PERSONAL" ? <span className="danger">*</span> : null} </label>
                      {/* <Form.Select size="md" className="sltareamodal" onChange={handleTowerSelect} >
                        <option value="" >Select Tower</option>
                        {towerList.map((item, index) => {
                          return (
                            <option key={index} value={item.towerId}>{item.towerName}</option>
                          )
                        })}
                      </Form.Select> */}
                      <SelectSearch
                        isSearchable={true}
                        clearable={towerIdComplainee ? true : false}
                        // options={towerOptions}
                        options={towerList ? towerList.map(item => ({ value: item.towerId, label: item.towerName })) : []}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        className="sltareamodal"
                        placeholder="Select Tower"
                        // values={
                        //   towerIdComplainee
                        //     ? towerOptions.filter(option => option.value === towerIdComplainee)
                        //     : []
                        // }
                        values={towerIdComplainee ? towerList.filter(item => item.towerId === towerIdComplainee).map(item => ({ value: item.towerId, label: item.towerName })) : []}
                        onChange={(values) => {
                          handleTowerSelect({ target: { value: values && values.length > 0 ? values[0].value : "" } });
                          setFlatComplaineeId("");
                          setFlatListComplainee([]);
                        }}
                        style={{
                          fontSize: '13px',
                          borderColor: '#ccc',
                          borderRadius: '4px',
                          height: '39px',
                          width: '100%',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          marginRight: 10
                        }}
                        dropdownStyle={{
                          width: '200px',
                          // zIndex: 9999
                        }}
                      />



                    </div>
                  </div>
                  <div className="col-md-6 ">
                    <div className="form-group text-left mt-2">
                      <label for="wfirstN"> Flat {requestType === "PERSONAL" ? <span className="danger">*</span> : null} </label>
                      {/* <Form.Select size="md" className="sltareamodal" onChange={handleFlatSelect} value={flatComplaineeId} >
                        <option value="" >Select Flat</option>
                        {flatListComplainee.map((item, index) => {
                          return (
                            <option key={index} value={item.flatId}>{item.flatName}</option>
                          )
                        })}
                      </Form.Select> */}
                      <SelectSearch
                        isSearchable={true}
                        clearable={flatComplaineeId ? true : false}
                        // options={flatOptions}
                        options={flatListComplainee ? flatListComplainee.map(item => ({ value: item.flatId, label: item.flatName })) : []}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        className="sltareamodal"
                        placeholder='Select Flat'

                        values={flatListComplainee.filter(item => item.flatId === flatComplaineeId).map(item => ({ value: item.flatId, label: item.flatName }))}
                        onChange={(values) => {
                          setFlatComplaineeId(values && values.length > 0 ? values[0].value : "");
                        }}
                        style={{
                          fontSize: '13px',
                          borderColor: '#ccc',
                          borderRadius: '4px',
                          height: '39px',
                          width: '100%',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          marginRight: 10
                        }}
                        dropdownStyle={{
                          width: '200px',
                          // zIndex: 9999
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group text-left mt-2">
                      <label for="wlastNa"> User  {requestType === "PERSONAL" ? <span className="danger">*</span> : null}</label>
                      <Form.Select size="md" className="sltareamodal" onChange={handleUserSelect} value={residentId}>
                        <option value="" >Select User</option>
                        {residentList.map((item, index) => {
                          return (
                            <option key={index} value={item.userMappingId}>{item.userName}</option>
                          )
                        })}
                      </Form.Select>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex" style={{ justifyContent: "flex-start", alignItems: "end" }}>
                    <div className="form-group text-left mt-2">
                      <input type="radio" id="urgen" name="isUrgent" value={true} onClick={handleIsUrgentSelect} checked={isUrgentComplainee} />
                      <label for="urgen">Is it Urgent?</label><br />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className='row'>
                  <div className='col-6'>
                    <div className="form-group text-left mt-2">
                      <label for="wfirstNam"> Category  <span className="danger">*</span> </label>
                      <Form.Select size="md" className="sltareamodal" onChange={handleCategorySelect} >
                        <option value="" >Select Category</option>
                        {categoryList.map((item, index) => {
                          return (
                            <option key={index} value={item.categoryId}>{item.categoryName}</option>
                          )
                        })}
                      </Form.Select>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className="form-group text-left mt-2">
                      <label for="Subcategory"> Subcategory </label>
                      <Form.Select id="Subcategory" size="md" className="sltareamodal" onChange={handleSubcategorySelect} value={subCategoryId}>
                        <option value="" >Select Subcategory</option>
                        {subcategoryList.map((item, index) => {
                          return (
                            <option key={index} value={item.subCategoryId}>{item.subCategoryName}</option>
                          )
                        })}
                      </Form.Select>
                    </div>
                  </div>

                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group text-left mt-2">
                  <label for="textarea"> Description <span className="danger">*</span> </label>
                  <textarea className="form-control required" name="firstName" aria-required="true" style={{ height: '45px' }} value={complaintDesc} onChange={(e) => setComplaintDesc(e.target.value)} />
                </div>

              </div>

              <div className="col-md-12 mb-2">
                <div className="form-group text-left mt-2">
                  <label for="Photo"> Attach Photo (Supported Formats: jpg, jpeg, png) </label>
                  <div className="form-group">
                    <div className="row ">
                      <div className='col-lg-3 col-md-3 col-sm-12 col-12'>
                        <label for="file-upload-0" className="helpcomplaint">
                          {base64img.length && base64img?.[0]?.base64String ? <img src={base64img?.[0]?.base64String} alt="img" style={{
                            width: '100%', height: '100%', objectFit: 'contain',
                          }} /> : <FontAwesomeIcon icon="fa-solid fa-plus" />}
                        </label>
                        <input id="file-upload-0" type="file" onChange={(e) => handleComplaineeFileSelect(e, "0")} />
                      </div>
                      <div className='col-lg-3 col-md-3 col-sm-12 col-12'>
                        <label for="file-upload-1" className="helpcomplaint">
                          {base64img.length && base64img?.[1]?.base64String ? <img src={base64img?.[1]?.base64String} alt="img" style={{
                            width: '100%', height: '100%', objectFit: 'contain',
                          }} /> : <FontAwesomeIcon icon="fa-solid fa-plus" />}
                        </label>
                        <input id="file-upload-1" type="file" onChange={(e) => handleComplaineeFileSelect(e, "1")} />
                      </div>
                      <div className='col-lg-3 col-md-3 col-sm-12 col-12'>
                        <label for="file-upload-2" className="helpcomplaint">
                          {base64img.length && base64img?.[2]?.base64String ? <img src={base64img?.[2]?.base64String} alt="img" style={{
                            width: '100%', height: '100%', objectFit: 'contain',
                          }} /> : <FontAwesomeIcon icon="fa-solid fa-plus" />}
                        </label>
                        <input id="file-upload-2" type="file" onChange={(e) => handleComplaineeFileSelect(e, "2")} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 col-md-12 d-flex mb-4">
                <div className="form-group text-left mt-2 d-flex col-12">
                  <div className='col-3 d-flex' style={{ alignItems: "end" }}>
                    <label for="urgen" style={{ whiteSpace: "nowrap", marginBottom: 6, marginLeft: -27 }}>Do you want to Assign someone ?</label>
                  </div>
                  <div className='col-4'>
                    <Form.Select id="Subcategory" size="md" className="sltareamodal" value={serviceStaffIdComplainee} onChange={handleServiceStaffSelect}>
                      <option value="" >Select Assign</option>
                      {serviceStaffList.map((item, index) => {
                        return (
                          <option key={index} value={item.staffId}>{item.userName}</option>
                        )
                      })}
                    </Form.Select>
                  </div>
                </div>
              </div>
            </div>

          </Modal.Body>

          <div className="cutomStriper_relative">
            <div className="cutombtn_area">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div className="d-flex flex-row-reverse">

                    <button type="button" className="btn btn-info" onClick={addComplaint} > Submit</button>
                    <button type="button" className="btn border bg-white" onClick={() => { setShow(false); compaintStateCleaner(); }}> Cancel</button>
                  </div>
                </div>
              </div>
            </div></div>
        </div>

      </Modal>



      <Modal scrollable
        fullscreen={fullscreen}
        show={show1}
        onHide={() =>
          CloseModal()}
        dialogclassName="modal-100w clientmodal"
        class="modal-dialog modal-fullscreen"
      >
        <Modal.Header closeButton className='headerMDL'>
          <Modal.Title id="example-custom-modal-styling-title"> Request Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="row" id="validation">
            <div className="col-md-7">
              <div className='noneditable'>

                <div className="conditionflex">
                  <div className='requesttitle'>
                    <h1>{complaintDetails?.complaintTitle} </h1>
                  </div>
                  <div className='idrequets'>
                    <span> Request#</span>
                    <h4> {complaintDetails?.complaintId} </h4>
                  </div>
                  <div className='iddate'>
                    <span> Created Date </span>
                    <h4> {convertDate_(complaintDetails?.createdDt)} </h4>
                  </div>
                </div>
                <div className='requesttitle'>
                  <div class="content">
                    <input type="checkbox" id="toggle" />
                    <p class="text">
                      {complaintDetails?.complaintDesc}
                      {/* <span class="more"> industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged</span> */}
                    </p>
                    {/* <label for="toggle" class="show-more">Show More</label>
                    <label for="toggle" class="show-less">Show Less</label> */}
                  </div>

                </div>

                <div className='flexbuilding'>
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='flex-tower'>
                        <span> Request Type </span>
                        <p>{complaintDetails?.applicableLevel}</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='flex-tower'>
                        <span> Urgent </span>
                        <p> {complaintDetails?.isUrgent ? "Yes" : "No"} </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='flex-flat'>
                        <span> Category / Sub-Category  </span>
                        {complaintDetails?.subCategoryName ? <p> {complaintDetails?.categoryName + " /" + complaintDetails?.subCategoryName} </p> : <p> {complaintDetails?.categoryName} </p>}
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='flex-flat'>
                        <span> Rating  </span>
                        {compRating ? <ReactStars
                          count={5}
                          value={compRating}
                          // isHalf = {true}
                          edit={false}
                          size={13}
                          activeColor="#ffd700"
                        /> : null}
                        {!compRating ? <ReactStars
                          count={5}
                          value={0}
                          edit={false}
                          size={13}
                          activeColor="#ffd700"
                        /> : null}
                      </div>
                    </div>
                    <div className='edithangbtn' onClick={() =>
                      setShow2(true)} >
                      <Link> Edit <FontAwesomeIcon icon={faPencil} /></Link>
                    </div>
                  </div>
                </div>
                <div className='editable'>
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='Requestype'>
                        <span> Status   </span>
                        <p> {complaintDetails?.statusName}</p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='category'>
                        <span> Assinged to  </span>
                        <p> <img src={assignedimg} /> {complaintDetails?.ssName}  </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='subcategory'>
                        <span> ETA </span>
                        <p> {convertDate_(complaintDetails?.eta)} </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='subcategory'>
                        <span> Aging </span>
                        <p> {complaintDetails?.aging} </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='editable'>
                  <div className="row">
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='Requestype'>
                        <span> Tower </span>
                        <p><FontAwesomeIcon icon={faBuilding} />  {complaintDetails?.towerName} </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='category'>
                        <span>  Flat </span>
                        <p> <FontAwesomeIcon icon={faBuildingUser} />  {complaintDetails?.flatName}  </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='subcategory'>
                        <span> Resident </span>
                        <p>  <img src={assignedimg} /> {complaintDetails?.userName} </p>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-ms-12 col-12">
                      <div className='subcategory'>
                        <span> Logged By </span>
                        <p> {complaintDetails?.complaintCreatedBy} </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div className="col-md-5">
              <div className='complaintarea'>
                <div className="complainttext">
                  <h4> Complaint Log </h4>
                </div>
                <div className="tableFixHead">
                  <div className="complainttbl">
                    <Table ordered striped>
                      <thead >
                        <tr>
                          <th className='complaintTablenopadding'>Action Date</th>
                          <th className='complaintTablenopadding'>Action By</th>
                          <th className='complaintTablenopadding'>Message </th>
                        </tr>
                      </thead>
                      <tbody>
                        {complaintDetails?.complaintAuditList.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td className='complaintTablenopadding'>  {convertDate_(item.actionDt)} </td>
                              <td className='complaintTablenopadding'> {item.actionBy} </td>
                              <td className='complaintTablenopadding'> {item.actionText} </td>
                            </tr>
                          )
                        })
                        }

                        <div>

                        </div>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
              <div className='log'>
                <div className="complainttext">
                  <h4> Comments </h4>
                </div>
                {/* <p>{complaintDetails?.comments}</p> */}
                {lines?.map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
                <div className="logstrip">
                  <div className="logbottombtns">
                    <div className='loginput'>
                      <input type="text" placeholder="Enter comment" value={userComment} onChange={handleCommentSet} />
                    </div>
                    <div className="d-flex">
                      <button type="button" className="btn btn-info" onClick={PostComments}> Add Comment</button>

                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div className="col-md-5">
              <div className='complaintimg'>
                <div className="complainttext">
                  <h4> Created Images </h4>
                </div>
                {complaintDetails?.complaintImageList?.filter(img => img.imageType === "CREATED").map((img, index) => (
                  <img key={index} onClick={() => {
                    if (img.awsImageURL) {
                      setShow9(true); setImgSrc(() => img.awsImageURL || "")
                    }
                  }}
                    src={img.awsImageURL || noimg}
                    className="img img-fluid"
                    alt={`Complaint Image ${index + 1}`}
                  />
                ))}
                <div className="complainttext">
                  <h4> Resolved Images </h4>
                </div>
                {complaintDetails?.complaintImageList?.filter(img => img.imageType === "RESOLVED").map((img, index) => (
                  <img key={index} onClick={() => {
                    if (img.awsImageURL) {
                      setShow9(true); setImgSrc(() => img.awsImageURL || "")
                    }
                  }}
                    src={img.awsImageURL || noimg}
                    className="img img-fluid"
                    alt={`Complaint Image ${index + 1}`}
                  />
                ))}
              </div>
            </div>
          </div>

        </Modal.Body>

      </Modal>



      <Modal show={show2} onHide={() => {
        setShow2(false);
      }} size='lg' className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
        <div style={{ width: "757px" }}>
          <Modal.Header closeButton className='headerMDL'>
            <Modal.Title id="example-custom-modal-styling-title"> Update Request</Modal.Title>
          </Modal.Header>
          <Modal.Body className="helpingElelemnt_uuy002" style={{ width: "auto" }}>

            <div className="row" id="validation">
              <div className="col-md-6 mb-2">
                <div className="form-group text-left mt-1">
                  <label for="RequestType"> Request Id </label>
                  <div className="form-group text-left d-flex justify-content-between">
                    <label for="Personal" className='mb-0'>{complaintDetails?.complaintId || ""}</label><br />
                  </div>
                </div>
              </div>
              <div className="col-md-6 mb-2">
                <div className='col-10 p-0'>
                  <div className="form-group text-left mt-1">
                    <label for="RequestType"> Request Type <span className="danger">*</span> </label>
                    <div className="form-group text-left d-flex justify-content-between">
                      <input type="radio" id="Personal" name="fav_language" value="PERSONAL" onChange={handleRequestTypeSelect} checked={requestType === "PERSONAL"} />
                      <label for="Personal" className='mb-0'>Personal Level</label><br />
                      <input type="radio" id="Society" name="fav_language" value="SOCIETY" onChange={handleRequestTypeSelect} checked={requestType === "SOCIETY"} />
                      <label for="Society" className='mb-0'> Society Level</label><br />

                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div className="row">
                  <div className="col-md-6 mb-2">

                    <div className="form-group text-left">
                      <label for="wfirst"> Tower {requestType === "PERSONAL" ? <span className="danger">*</span> : null} </label>
                      {/* <Form.Select size="md" className="sltareamodal" onChange={handleTowerSelect} value={towerIdComplainee} >
                        <option value="" >Select Tower</option>
                        {towerList.map((item, index) => {
                          return (
                            <option key={index} value={item.towerId}>{item.towerName}</option>
                          )
                        })}
                      </Form.Select> */}
                      <SelectSearch
                        options={towerList ? towerList.map(item => ({ value: item.towerId, label: item.towerName })) : []}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        className="sltareamodal"
                        placeholder="Select Tower"
                        values={towerIdComplainee ? towerList.filter(item => item.towerId === towerIdComplainee).map(item => ({ value: item.towerId, label: item.towerName })) : []}
                        onChange={(values) => {
                          handleTowerSelect({ target: { value: values && values.length > 0 ? values[0].value : "" } });
                          setFlatComplaineeId("");
                          setFlatListComplainee([]);
                        }}
                        style={{
                          fontSize: '13px',
                          borderColor: '#ccc',
                          borderRadius: '4px',
                          height: '39px',
                          width: '100%',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          marginRight: 10
                        }}
                        dropdownStyle={{
                          width: '200px',
                          // zIndex: 9999
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-2">
                    <div className="form-group text-left">
                      <label for="wfirstN"> Flat {requestType === "PERSONAL" ? <span className="danger">*</span> : null} </label>
                      {/* <Form.Select size="md" className="sltareamodal" onChange={handleFlatSelect} value={flatComplaineeId} >
                        <option value="" >Select Flat</option>
                        {flatListComplainee.map((item, index) => {
                          return (
                            <option key={index} value={item.flatId}>{item.flatName}</option>
                          )
                        })}
                      </Form.Select> */}
                      <SelectSearch
                        options={flatListComplainee ? flatListComplainee.map(item => ({ value: item.flatId, label: item.flatName })) : []}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        className="sltareamodal"
                        placeholder='Select Flat'
                        values={flatListComplainee.filter(item => item.flatId === flatComplaineeId).map(item => ({ value: item.flatId, label: item.flatName }))}
                        onChange={(values) => {
                          handleFlatSelect({ target: { value: values && values.length > 0 ? values[0].value : "" } });
                        }}
                        style={{
                          fontSize: '13px',
                          borderColor: '#ccc',
                          borderRadius: '4px',
                          height: '39px',
                          width: '100%',
                          backgroundColor: '#fff',
                          textAlign: 'left',
                          marginRight: 10
                        }}
                        dropdownStyle={{
                          width: '200px',
                          // zIndex: 9999
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group text-left mt-1">
                      <label for="wlastNa"> User  {requestType === "PERSONAL" ? <span className="danger">*</span> : null}</label>
                      <Form.Select size="md" className="sltareamodal" onChange={handleUserSelect} value={residentId}>
                        <option value="" >Select User</option>
                        {residentList.map((item, index) => {
                          return (
                            <option key={index} value={item.userMappingId}>{item.userName}</option>
                          )
                        })}
                      </Form.Select>
                    </div>

                  </div>
                  <div className='col-md-6 mb-2 d-flex' style={{ alignItems: "end" }}>
                    <div className="form-group text-left mt-2">
                      <input type="radio" id="urgen" name="isUrgent" value={true} onClick={handleIsUrgentSelect} checked={isUrgentComplainee} />
                      <label for="urgen" className='mb-0'>Is it Urgent?</label><br />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className='row'>
                  <div className='col-6'>
                    <div className="form-group text-left mt-2">
                      <label for="wfirstName2"> Category <span className="danger">*</span> </label>
                      <Form.Select size="md" className="sltareamodal" onChange={handleCategorySelect} value={categoryIdComplainee}>
                        <option value="" >Select Category</option>
                        {categoryList.map((item, index) => {
                          return (
                            <option key={index} value={item.categoryId}>{item.categoryName}</option>
                          )
                        })}
                      </Form.Select>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className="form-group text-left mt-2">
                      <label for="wlastName2"> Subcategory   </label>
                      <Form.Select size="md" className="sltareamodal" onChange={handleSubcategorySelect} value={subCategoryId}>
                        <option value="" >Select Subcategory</option>
                        {subcategoryList.map((item, index) => {
                          return (
                            <option key={index} value={item.subCategoryId}>{item.subCategoryName}</option>
                          )
                        })}

                      </Form.Select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className='row'>
                  <div className='col-6'>
                    <div className="form-group text-left mt-2">
                      <label for="Assignedto"> Assigned to </label>
                      <label style={{ color: "blue", textDecoration: "underline", cursor: "pointer", float: 'right' }} onClick={() => setAssignmentModal(true)}>
                        Assignments by Staff
                      </label>
                      <Form.Select size="md" className="sltareamodal" value={serviceStaffIdComplainee} onChange={handleServiceStaffSelect} >
                        <option value="" >Select Assigned To</option>
                        {serviceStaffList.map((item, index) => {
                          return (
                            <option key={index} value={item.staffId}>{item.userName}</option>
                          )
                        })}
                      </Form.Select>
                    </div>
                    {/* <div className="form-group text-left mt-1">
                        <label for="IsUrgent"> Urgent  </label><br />
                        <div className="form-group text-left d-flex justify-content-between">
                          <input type="radio" id="yes" name="Urgent" value={true} onChange={handleIsUrgentSelect} checked={isUrgentComplainee} />
                          <label for="yes" className='mb-0'> Yes</label>
                          <input type="radio" id="no" name="Urgent" value={false} onChange={handleIsUrgentSelect} checked={!isUrgentComplainee} />
                          <label for="no" className='mb-0'> No</label><br />
                        </div> 
                    </div> */}
                  </div>
                  <div className='col-6'>
                    <div className="form-group text-left mt-2">
                      <label for="Status"> Status </label>
                      <Form.Select size="md" className="sltareamodal" onChange={handleStatusSelect} value={complaintStatusId}>
                        <option value="" >Select Status</option>
                        {complaintStatusList.map((item, index) => {
                          return (
                            <option key={index} value={item.statusId} disabled={item.statusName.toUpperCase() === "REOPEN" && reopenBtn}>{item.statusName}</option>
                          )
                        })}
                      </Form.Select>
                    </div>
                  </div>
                </div>

              </div>

              <div className="col-md-12 mb-1">
                <div className='row'>
                  <div className='col-6'>
                    <div className="form-group text-left mt-2" style={{ pointerEvents: isDisabled ? 'none' : 'auto' }}>
                      <label for="Reason"> Reason {!isDisabled && <span style={{ color: 'red' }}>*</span>} </label>
                      <Form.Select size="md" className="sltareamodal" onChange={handleReasonSelect} value={reasonId}>
                        <option value="" >Select Reason</option>
                        {reasonList.map((item, index) => {
                          return (
                            <option key={index} value={item.reasonId}>{item.reasonText}</option>
                          )
                        })}
                      </Form.Select>
                    </div>
                  </div>

                  <div className='col-6'>
                    <div className="form-group text-left mt-2">
                      <label for="ETA"> Expected turn around time <span className="danger">*</span></label>
                      <input type="datetime-local" min={todayDateGet()} placeholder="DD/MM/YY" className="form-control required" value={ETAdate} onChange={handleETADateSelect} />
                    </div>
                  </div>
                </div>

              </div>



              {/* <div className="col-md-12 mb-5">
                

              </div> */}

            </div>

          </Modal.Body>
          <div className="cutomStriper">

            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="d-flex flex-row-reverse">

                <button type="button" className="btn border bg-white" onClick={() => { setShow2(false) }}> Cancel</button>
                <button type="button" className="btn btn-info" onClick={updateComplaint}> Update</button>
              </div>
            </div>

          </div>


          {/* <div className="cutomStriper">

            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="d-flex flex-row-reverse">

                <button type="button" className="btn btn-info" onClick={updateComplaint}> Update</button>
                <button type="button" className="btn border bg-white" onClick={() => { setShow2(false) }}> Cancel</button>
              </div>
            </div>

          </div> */}
        </div>

      </Modal>



      <Modal
        show={show9}
        onHide={() => setShow9(false)}
        size="md"
        className="m-0 p-0 pt-5"
      >
        <Modal.Header className="headerMDL" closeButton>
          <Modal.Title
            id="example-modal-sizes-title-lg"
            onClick={() => setShow9(false)}
          >
            Image
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-2">
          <div className="border-hike">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                <img src={imgSrc} className="img img-fluid" alt='Complaint Image' />

              </div>
            </div>
          </div>
        </Modal.Body>

      </Modal>

      <Modal
        show={show8}
        onHide={() => setShow8(false)}
        size="md"
        className="m-0 p-0 pt-5"
      >
        <Modal.Header className="headerMDL" closeButton>
          <Modal.Title
            id="example-modal-sizes-title-lg"
            onClick={() => setShow8(false)}
          >
            Advance search
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-2">
          <div className="border-hike">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
                <div className='row'>
                  <div className='col-6'>
                    <Select
                      isMulti
                      placeholder="Select Status"
                      options={options}
                      onChange={handleChange}
                      value={selectedOptions}
                      className="d-inline-block ml-auto w-100"
                    />
                  </div>
                  <div className='col-6'>
                    <Select
                      isMulti
                      placeholder="Select Category"
                      options={optionsCategory}
                      onChange={handleCategoryChange}
                      value={selectedCategories}
                      className="d-inline-block ml-auto w-100"
                    />
                  </div>
                  <div className='col-6 mt-4'>
                    <Select
                      isMulti
                      placeholder="Select Assigned"
                      options={optionsStaff}
                      onChange={handleChangeStaff}
                      value={selectedStaff}
                      className="d-inline-block ml-auto w-100"
                    />
                  </div>
                </div>
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </Modal.Body>
        <div class="fixed_allbtn">
          <div class="upload_btn">
            <ul role="menu" aria-label="Pagination" class="mb-0">
              <div class="  align-self-start">
                <button
                  type="button"
                  class="btn btn-primary border mr-2"
                  onClick={() => SearchComplaint()}
                >
                  {" "}
                  Search
                </button>
                <button
                  type="button"
                  class="btn border bg-white mr-2"
                  onClick={() => setShow8(false)}
                >
                  {" "}
                  Cancel
                </button>
              </div>
            </ul>
          </div>
        </div>
      </Modal>

      {/* modal for complaints assigned to staff */}

      {assignmentModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
          onClick={() => setAssignmentModal(false)}
        >
          <div
            className="modal-dialog modal-lg"
            style={{ width: '60%' }}
            onClick={(e) => e.stopPropagation()}

          >
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title">Current Assignment</h5>
                <button
                  className="btn-close"
                  onClick={() => setAssignmentModal(false)}
                ></button>
              </div>

              {/* Modal Body */}

              <div className="modal-body" >
                <div className="col-lg-12 col-md-12 col-sm-12 col-12" >
                  <div className="Charts__0093_Element" >
                    {AssignedLoading ? (
                      <span className="skeleton-loader_chart"></span>
                    ) : null}
                    {AssignedCount.length ? (
                      <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                        <Chart
                          chartType="BarChart"
                          width="100%"
                          height={`${data2.length * 50}px`}
                          data={data2}
                          options={{
                            chartArea: { width: "60%", height: "100%", top: 5, bottom: 60, },
                            hAxis: { title: "Complaint Count" },
                            vAxis: { title: "Staff Name", textStyle: { fontSize: 12 } },
                            legend: { position: "none" },
                            bar: { groupWidth: "50%" },
                          }}
                        />
                      </div>
                      // </div>
                    ) : (
                      <p
                        style={{
                          backgroundColor: "#fff",
                          textAlign: "center",
                          height: 330,
                          paddingTop: 145,
                        }}
                      >
                        No data
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Modal
        show={showEscalationModal}
        fullscreen={true}
        onHide={() => setShowEscalationModal(false)}
        aria-labelledby="escalation-modal"
        centered
        size="xl"
      >
        <Modal.Header closeButton className="headerMDL">
          <Modal.Title id="escalation-modal">Escalation Management</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: 0 }}>
          {/* Render the Escalation component inside modal */}
          {showEscalationModal && <Escalation />}
        </Modal.Body>
      </Modal>

    </>
  );
}
export default Helpdesk;